export enum ChangeType {
    SERIES = "SERIES",
    OCCURRENCE = "OCCURRENCE"
}
